import React from 'react';
import { useSelector } from 'react-redux';
import { selectNoScopeValidationScope } from '../../../util/useSelectorFunctions';
import { ResourceType } from '../../../../resource/enumerations/ResourceType';
import { useNestedDialogFunction } from '../../../../../../react-commons/dialog-provider/UseNestedDialogFunction';
import { useDeleteResourceDialogFunction } from '../../../reusable-components/dialogs/UseDeleteResourceDialogFunction';
import {
    getDefaultVCycleElementResource,
    useVCycleElementActions,
    VCycleElementParentRelation,
    VCycleElementPropertyValidation,
} from '../../../../resource/resources/artifacts/use_case/representation/vcycleElementResource';
import { VCycleElementEditDialog } from '../vcycle-element/VCycleElementEditDialog';
import { VCycleElementCreationDialog } from '../vcycle-element/VCycleElementCreationDialog';
import { VCycleElementType } from '../../../../resource/enumerations/VCycleElementType';
import { NonCollapsibleQueryStateComponent } from '../../../reusable-components/base/NonCollapsibleQueryStateComponent';
import {
    ControlledReferenceInputs,
} from '../../../reusable-components/base/reference-text-fields/ControlledReferenceInputs';

export const VCycleElementDisplay = ({
                                         parentId,
                                         projectId,
                                         projectVersionId,
                                     }: {
    parentId?: string;
    projectId: string | undefined | null;
    projectVersionId: string | undefined | null;
}) => {

    const deleteResourceDialogFunction = useDeleteResourceDialogFunction();
    const nestedDialog = useNestedDialogFunction();

    const noScope = useSelector(selectNoScopeValidationScope);
    const vcycleElementActions = useVCycleElementActions()
    const vcycleElementQuery = vcycleElementActions.useGetSingleResource(VCycleElementParentRelation.V_CYCLE_REPRESENTATION_V_CYCLE_ELEMENT_CONTAINER, parentId);
    const validationQuery = vcycleElementActions.useValidateResource(
        vcycleElementQuery.data?.id,
        noScope,
    );
    const deleteVCycleElement = vcycleElementActions.useDeleteResource();

    const openEditDialog = () => {
        const resource = vcycleElementQuery.data;
        if (resource) {
            nestedDialog.showNestedDialog(
                <VCycleElementEditDialog
                    onClose={nestedDialog.closeNestedDialog}
                    objectId={resource.objectId}
                    projectId={projectId}
                    versionedInId={resource.versionedIn}
                />,
            );
        }
    };

    const openAddDialog = () => {
        nestedDialog.showNestedDialog(
            <VCycleElementCreationDialog
                projectId={projectId}
                projectVersionId={projectVersionId}
                onClose={nestedDialog.closeNestedDialog}
                parentId={parentId ?? ''}
                autoGeneratedProps={({
                    ...getDefaultVCycleElementResource(VCycleElementType.REPRESENTATION),
                })}
            />,
        );
    };

    return (
        <NonCollapsibleQueryStateComponent
            query={vcycleElementQuery}
            resourceType={ResourceType.V_CYCLE_ELEMENT}
            label={'V-Cycle Element'}
            readOnly={true}
            validationResource={validationQuery.data}
            handleAddClick={openAddDialog}
            handleEditClick={openEditDialog}
            handleDeleteClick={() => {
                const resource = vcycleElementQuery.data;
                if (resource) {
                    deleteResourceDialogFunction.deleteResource(
                        resource.id,
                        undefined,
                        ResourceType.V_CYCLE_ELEMENT,
                        deleteVCycleElement,
                    );
                }
            }}
        >
            {(vcycleElementQuery.data && 'representation' in vcycleElementQuery.data) &&
                <ControlledReferenceInputs.WorkflowRepresentation
                    objectId={vcycleElementQuery.data.representation}
                    readOnly={true}
                    projectVersionId={projectVersionId}
                    projectId={projectId}
                    propertyValidationInformation={{
                        resourceType: ResourceType.V_CYCLE_ELEMENT,
                        propertyIdentifier: VCycleElementPropertyValidation.REPRESENTATION,
                        resourceId: vcycleElementQuery.data.id,
                    }}
                />
            }
        </NonCollapsibleQueryStateComponent>
    );
};